/**
* サーバー時刻を取得し、秒数に変換。
* サーバーのレスポンスヘッダーから時刻を取得してコールバック関数に渡す。取得できなかった場合、クライント時刻を渡す関数。
*/
function getServerDate(callback) {
  let now = null;
  $.ajax({
    type : 'HEAD',
    url :  window.location.href,
    cache : false
  }).done(function(data, textStatus, xhr) {
    try {
      serverDate = new Date(xhr.getResponseHeader("Date"));
      now = Math.floor(serverDate.getTime() / 1000);
    } catch(e) {
      now = Math.floor(new Date() / 1000);
    }
    callback(now);
  }).fail(function() {
    now = Math.floor(new Date() / 1000);
    callback(now);
  });
}